import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { stdlib } from '../lib/std';
export var library = stdlib();
// @todo Warn if override existing key.
export function register(key, component) {
  Object.assign(library, _defineProperty({}, key, component));
}